<div class="relative">
    <button
        type="button"
        class="flex items-center justify-center relative p-2 min-w-[2.5rem] hover:rounded-[62.4375rem] hover:bg-[#F6F7FF]"
        [matMenuTriggerFor]="dropdownMenu">
        <img
            src="/assets/images/shared/notification-grey-icon.svg"
            alt="Notification icon"
            class="h-5 w-5 object-cover" />
        @if (NotificationsData()?.unreadCount?.all! > 0) {
            <span
                class="absolute -top-1 -right-1 bg-[#4F66FF] text-white text-xs rounded-full h-5 min-w-[1.25rem] px-1 flex items-center justify-center font-medium"
                >{{ NotificationsData()?.unreadCount?.all }}</span
            >
        }
    </button>

    <!-- Dropdown Menu -->
    <mat-menu #dropdownMenu="matMenu">
        <div
            class="flex justify-between items-center space-x-2 px-4 py-3 border-b border-[#E7EAF0]"
            (click)="$event.stopPropagation()">
            <p class="text-[1rem]">Notifications</p>
            <p
                class="bg-[#4F66FF] text-white text-xs rounded-full h-5 min-w-[1.25rem] px-1 flex items-center justify-center font-medium">
                {{ NotificationsData()?.unreadCount?.all }}
            </p>
        </div>
        <!-- Notification List -->
        <div class="flex flex-col gap-1">
            @for (notification of NotificationsData()?.notifications?.slice(0, 2); track notification) {
                <div
                    class="flex gap-3 px-4 py-3 border-l-4 border-[#4F66FF] cursor-pointer hover:bg-[#F6F7FF]"
                    [ngClass]="notification.isRead ? 'border-none' : 'bg-[#F6F7FF]'"
                    (click)="onNotificationRead(notification); onNotificationClick(notification)">
                    @if (notification.sender) {
                        @if (notification.sender.photo !== ' ' && notification.sender.photo) {
                            <img
                                class="w-8 h-8 rounded-full object-cover border border-[#e7eaf0]"
                                alt="Profile"
                                [src]="notification.sender.photo" />
                        } @else {
                            <div
                                class="w-8 h-8 rounded-full border border-[#e7eaf0] bg-white text-[#4F66FF] flex items-center justify-center font-bold text-[1.2rem]">
                                {{ notification.sender.name.charAt(0) | uppercase }}
                            </div>
                        }
                    } @else {
                        <img
                            class="w-8 h-8 rounded-full object-contain border border-[#e7eaf0]"
                            alt="Profile"
                            [src]="'/assets/images/auth/interseed-new-logo.png'" />
                    }
                    <div class="flex-1 flex justify-between items-start">
                        <div class="flex flex-col gap-1">
                            <p class="text-[#0A0A0A]" [innerHTML]="notification.message"></p>
                            <div class="flex justify-between items-center gap-6">
                                <p class="text-[#717182]">{{ timeAgo(notification.createdAt) }}</p>
                            </div>
                        </div>
                        @if (!notification.isRead) {
                            <div class="flex flex-col justify-between items-end h-full">
                                <div class="h-2 w-2 bg-[#4F66FF] rounded-full flex-shrink-0"></div>
                                <p class="text-[#4F66FF] text-right whitespace-nowrap">Mark read</p>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>

        <div class="flex justify-center px-4 pt-3 pb-1">
            <button
                type="button"
                class="w-full border rounded-xl py-2 px-4 text-[#4F66FF] hover:bg-[#4F66FF] hover:text-white"
                [routerLink]="['/notification']">
                View all notifications
            </button>
        </div>
    </mat-menu>
</div>
